import type { InstalledModule, InstalledModuleMenu } from '../types.ts';

/** Đường dẫn gốc (chưa có tiền tố cổng) của mọi màn module, `routes/index.tsx` khai cùng mẫu. */
export const GOC_MAN_MODULE = '/m';

export interface MucMenuModule {
  nhan: string;
  /** Đường dẫn gốc, ví dụ `/m/demo-sdk/cong-viec`; Sidebar ghép tiền tố cổng. */
  href: string;
  /** `path` của menu là `/`: chỉ sáng đúng trang gốc, không sáng theo mọi trang con của module. */
  laGoc: boolean;
}

export interface NhomMenuModule {
  code: string;
  ten: string;
  muc: MucMenuModule[];
}

/**
 * `path` của `menus` do bên nộp gói khai, không tin cậy: chỉ nhận đường dẫn tương đối gọn,
 * không `..`, không `//`, không ký tự ngoài tập an toàn của URL.
 */
export function pathMenuHopLe(path: string): boolean {
  if (!/^\/(?:[A-Za-z0-9._~-]+(?:\/[A-Za-z0-9._~-]+)*\/?)?$/.test(path)) return false;
  return !path.split('/').some((doan) => doan === '.' || doan === '..');
}

function goc(path: string): string {
  return path === '/' ? '/' : path.replace(/\/$/, '');
}

/**
 * Mỗi module đã cài có giao diện thành một nhóm trên thanh điều hướng, ngang các nhóm của cổng; mỗi mục
 * `menus` mà người dùng có quyền thành một mục. Module không còn mục nào thấy được thì không có nhóm.
 */
export function nhomMenuModule(
  danhSach: readonly InstalledModule[],
  coQuyen: (ma: string) => boolean,
): NhomMenuModule[] {
  return danhSach.flatMap((m) => {
    if (!m.frontend_remote) return [];
    const muc = m.menus
      .filter((menu) => pathMenuHopLe(menu.path) && coQuyen(menu.permission))
      .map((menu) => {
        const p = goc(menu.path);
        return { nhan: menu.label, href: `${GOC_MAN_MODULE}/${m.code}${p === '/' ? '' : p}`, laGoc: p === '/' };
      });
    return muc.length > 0 ? [{ code: m.code, ten: m.name, muc }] : [];
  });
}

/** Mục menu của trang đang xem: khớp dài nhất, để breadcrumb nói đúng màn nào của module. */
export function menuDangXem(module: InstalledModule, path: string): InstalledModuleMenu | undefined {
  const p = goc(path || '/');
  return module.menus
    .filter((menu) => pathMenuHopLe(menu.path))
    .filter((menu) => {
      const m = goc(menu.path);
      return m === '/' ? p === '/' : p === m || p.startsWith(`${m}/`);
    })
    .sort((a, b) => goc(b.path).length - goc(a.path).length)[0];
}
